import React from "react";
import { CaretDoubleDown } from "phosphor-react";
import Image from "../assets/Imagem.png";

export default function About() {
  return (
    <div className="tw-flex tw-h-screen tw-flex-col lg:tw-flex-row tw-items-center tw-justify-evenly lg:tw-justify-between tw-py-10 lg:tw-py-20 tw-px-8 lg:tw-px-16 lg:tw-px-32 xl:tw-px-64">
      <div className="tw-w-full tw-mt-8 lg:tw-w-2/3 xl:tw-w-3/4 tw-mb-12 lg:tw-mb-0">
        <p className="tw-text-left tw-text-2xl  lg:tw-text-4xl tw-font-bold tw-text-[#D0E8F4]">
          Front-end developer
        </p>
        <p className="tw-text-left tw-my-4 tw-text-4xl lg:tw-text-5xl  tw-font-bold tw-text-[#D0E8F4]">
          Olá, me chamo Pablo Kauê! :)
        </p>
        <div className="tw-w-full lg:tw-w-3/4">
          <p className="tw-text-left tw-indent-11  tw-text-xl lg:tw-text-2xl  tw-text-[#D0E8F4]">
            "Sou Desenvolvedor Jr apaixonado por programação, possuo habilidades
            em ReactNative, ReactJs, VueJs, Laravel, PHP e UI/UX. Sou
            comprometido em criar soluções eficientes e atualizadas. Buscando
            constantemente aprender e evoluir na área e pronto para contribuir
            em projetos desafiadores."
          </p>
        </div>
        <div className="tw-group tw-cursor-pointer">
          <a
            href="../assets/Pablokaue.pdf"
            download
            className="tw-px-3 tw-py-2 tw-mt-6 tw-w-full lg:tw-w-auto tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border-2 tw-border-white hover:tw-bg-white hover:tw-text-black tw-transition tw-duration-150"
          >
            <p className="tw-text-lg lg:tw-text-xl tw-font-bold tw-text-[#D0E8F4] group-hover:tw-text-black">
              Baixar currículo
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="tw-w-6 tw-h-6 tw-ml-2 tw-text-[#D0E8F4] group-hover:tw-text-black group-hover:tw-duration-150"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="tw-w-2/4 lg:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-[40%] lg:tw-mb-0">
        <img
          src={Image}
          alt=""
          className="tw-mx-auto lg:tw-mx-0 tw-select-none"
        />
      </div>
      <div className="tw-absolute tw-animate-bounce tw-bottom-5 tw-right-1/2 tw-transform tw-translate-x-1/2">
        <CaretDoubleDown size={20} color="white" />
      </div>
    </div>
  );
}
